import PublicUploader from './PublicUploader'

export default PublicUploader
